import React, { useCallback, useContext, useEffect, useState } from "react";
import { Flex, InlineNotification, Modal, useTranslation } from "@familyzone/component-library";
import { UserSearchSelector } from "../UserSearch/UserSearchSelector";
import { UserOption } from "../../types/Users";
import { ReactRouterCompatContext } from "../ContextProvider";
import { InjectedRouter } from "react-router";
import { useReportingUserStore } from "../../storez/ReportingUserStore";
import { ResponseError } from "../../types/Api";

interface FindUserModalProps {
  open: boolean;
  onClose: () => void;
}

const FindUserModal: React.FC<FindUserModalProps> = ({ open = false, onClose = () => "" }) => {
  const { router } = useContext(ReactRouterCompatContext) as { router: InjectedRouter };
  const { t } = useTranslation();

  const [selected, setSelected] = useState<UserOption>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (!open) {
      setSelected(undefined);
      setError(undefined);
    }
  }, [open]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleUserSelect = (selected: UserOption | null) => {
    setSelected(undefined);
    if (selected?.id) {
      useReportingUserStore
        .getState()
        .getUser(selected.id)
        .then(
          () => {
            setSelected(selected);
            setError(undefined);
          },
          (err: ResponseError) => {
            if ("status" in err && err.status === 403) {
              setError("You are not authorized to access the selected user data");
            }
          }
        );
    }
  };

  const handleClickSubmit = () => {
    if (!selected || !selected.id) return;
    handleClose();
    router.push(`/surfwize/reporting/users/${selected.id}`);
  };

  return (
    <Modal
      headerText={t("Find User")}
      size="md"
      isOpen={open}
      onClose={handleClose}
      contentProps={{ style: { overflow: "visible" } }}
      primaryCTALabel={t("Go to User Dashboard")}
      primaryCTADisabled={!selected}
      onPrimaryCTAClick={handleClickSubmit}
      secondaryCTALabel={t("Cancel")}
      onSecondaryCTAClick={handleClose}
    >
      <Flex mt="sp24" gap="sp16" direction="column">
        <UserSearchSelector placeholderText={t("Enter username, email or name")} handleChange={handleUserSelect} useQoriaUsers={true} />
        {error && <InlineNotification status="error" notificationDescription={error} />}
      </Flex>
    </Modal>
  );
};

export default FindUserModal;
